var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 43,
    viewBox: "0 0 26 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38_553",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 43
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.307 24.307L7.30698 41.307C6.50542 42.0811 5.43186 42.5095 4.31752 42.4998C3.20319 42.4902 2.13723 42.0432 1.34925 41.2552C0.561264 40.4672 0.114297 39.4013 0.104613 38.2869C0.09493 37.1726 0.523306 36.099 1.29748 35.2975L15.2927 21.3022L1.29748 7.30697C0.891559 6.91492 0.567782 6.44596 0.345044 5.92744C0.122306 5.40893 0.00506418 4.85124 0.000160462 4.28693C-0.00474326 3.72262 0.102792 3.16298 0.316486 2.64067C0.53018 2.11836 0.845755 1.64384 1.2448 1.2448C1.64384 0.845751 2.11836 0.530176 2.64067 0.316482C3.16298 0.102788 3.72262 -0.00474325 4.28693 0.000160467C4.85124 0.00506419 5.40893 0.122306 5.92745 0.345044C6.44596 0.567782 6.91493 0.891557 7.30698 1.29748L24.307 18.2975C25.1037 19.0945 25.5513 20.1753 25.5513 21.3022C25.5513 22.4292 25.1037 23.51 24.307 24.307Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38_553)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_38_553)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5,
    cy: -24.5,
    rx: 39.5,
    ry: 40.5,
    fill: "#36CF5D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_38_553)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5,
    cy: -19.5,
    rx: 39.5,
    ry: 40.5,
    fill: "#FFE712"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_38_553)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.5,
    cy: -6.5,
    rx: 39.5,
    ry: 40.5,
    fill: "#FD2E1B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_38_553)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -22.5,
    cy: 32.5,
    rx: 39.5,
    ry: 40.5,
    fill: "#C03AEC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_38_553",
    x: -46,
    y: -85,
    width: 119,
    height: 121,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_38_553"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_38_553",
    x: -46,
    y: -80,
    width: 119,
    height: 121,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_38_553"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_38_553",
    x: -53,
    y: -67,
    width: 119,
    height: 121,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_38_553"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_38_553",
    x: -82,
    y: -28,
    width: 119,
    height: 121,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_38_553"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.a9178c280c77af81dbf69e9d22fe39f5.svg";
export { ForwardRef as ReactComponent };